export default {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: `Neizdevās nosūtīt, {Retry}.`,
  // SLOW_CONNECTION_NOTIFICATION: '',
  Chat: 'Tērzēšana',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': 'Klausoties…',
  Retry: 'Mēģināt vēlreiz',
  Send: 'Sūtīt',
  Sending: 'Nosūtīšana',
  // 'Speak': '',
  // 'Starting…': '',
  Tax: 'Nodoklis',
  Total: 'Kopsumma',
  'Type your message': 'Ierakstiet savu ziņu',
  // 'Upload file': '',
  VAT: 'VAT'
  // 'X minutes ago':
};
